import { Avatar } from '@mui/material'
import { styled } from '@mui/material/styles'

const SmallAvatar = styled(Avatar)`
  max-width: 100%;
  max-height: 100%;
`

export default SmallAvatar
